export const onUrlChanges = [];

let prevUrl = window.location.pathname;

setInterval(() => {
  const currentUrl = window.location.pathname;

  if (currentUrl !== prevUrl) {
    for (const fn of onUrlChanges) {
      fn(prevUrl, currentUrl);
    }

    prevUrl = currentUrl;
  }
}, 1000);
